import React from "react";
import { Trophy, MessageCircle } from "lucide-react";
import { BRAND } from "../config/brand";

function buildWaLink(c) {
  const msg = `Olá! Quero assistir os jogos da *${c.name}* pelo MasterX HD. Como faço para contratar?`;
  return `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(msg)}`;
}

const CardBackground = ({ c }) =>
  c.image ? (
    <>
      <img src={c.image} alt={c.name} className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-black/55" />
    </>
  ) : (
    <div className="absolute inset-0 opacity-20 pointer-events-none">
      <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-white/20 blur-2xl" />
      <div className="absolute -bottom-8 -left-8 w-32 h-32 rounded-full bg-white/10 blur-2xl" />
    </div>
  );

const CardCover = ({ c }) => (
  <div className={`relative bg-gradient-to-br ${c.gradient} p-6 h-52 flex flex-col justify-between overflow-hidden`}>
    <CardBackground c={c} />
    <div className="relative flex items-center justify-between">
      <span className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md bg-black/50 backdrop-blur-sm text-[10px] font-bold uppercase tracking-widest text-white/90">
        <Trophy className="w-3 h-3 text-yellow-400" />
        Campeonato
      </span>
      {!c.image && (
        <span className={`w-14 h-14 rounded-full ${c.accent} border-4 border-white/20 flex items-center justify-center text-white font-extrabold text-lg tracking-wider shadow-xl`}>
          {c.badge}
        </span>
      )}
    </div>
    <div className="relative">
      <h3 className="text-white text-xl font-extrabold leading-tight drop-shadow-lg">{c.name}</h3>
      <p className="text-white/85 text-xs mt-1.5 line-clamp-2 drop-shadow">{c.tagline}</p>
    </div>
  </div>
);

export const ChampionshipCard = ({ c }) => (
  <a
    href={buildWaLink(c)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`championship-${c.id}`}
    className="shrink-0 w-[280px] snap-start rounded-2xl overflow-hidden border border-white/10 hover:border-yellow-500/50 hover:-translate-y-1 transition group"
  >
    <CardCover c={c} />
    <div className="bg-surface p-4 flex items-center justify-between gap-3">
      <div className="text-[11px] text-white/60 leading-tight min-w-0">
        <p className="uppercase tracking-wider font-bold text-white/40">Onde passa</p>
        <p className="text-white/85 font-semibold truncate">{c.channels}</p>
      </div>
      <span className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full bg-[#25D366] text-white text-[11px] font-bold shadow-md group-hover:brightness-110 transition shrink-0">
        <MessageCircle className="w-3.5 h-3.5" /> Contratar
      </span>
    </div>
  </a>
);
